export const SET_FAVOURITE_QUESTIONS = 'SET_FAVOURITE_QUESTIONS';
export const CLEAR_FAVOURITE_QUESTIONS = 'CLEAR_FAVOURITE_QUESTIONS';
